<script setup lang="ts">
const { isMobile } = useResponsive();
const { tt } = useTypedI18n();
</script>

<template>
    <UModal :fullscreen="isMobile" :title="tt('fees.infoModal.title')" :ui="{ content: 'max-w-3xl' }" v-bind="modalNoDescAriaFixupProps">
        <UButton class="p-0" color="neutral" variant="ghost" size="xs">
            <UIcon name="lucide:info" />
        </UButton>

        <template #body>
            <div class="flex flex-col gap-6">
                <p class="text-center font-medium">
                    {{ tt('fees.infoModal.subtitle') }}
                </p>

                <SaleFeesInfoTable />

                <p class="text-center text-sm font-bold">{{ tt('fees.infoModal.bottomNotice') }}</p>
            </div>
        </template>
    </UModal>
</template>
